<!-- src/components/EditRecordDialog.vue -->
<template>
<Teleport to="#modal-target" disabled="!document.querySelector('#modal-target')">
  <div class="edit-dialog-overlay">
    <div class="edit-dialog">
      <div class="edit-form">
        <div class="form-group">
          <label for="bookingNumber">Booking number</label>
          <input
            id="bookingNumber"
            v-model="formData.bookingNumber"
            type="text"
          />
        </div>
        
        <div class="form-group">
          <label for="detainee">Detainee</label>
          <input
            id="detainee"
            v-model="formData.detainee"
            type="text"
          />
        </div>
        
        <div class="form-group">
          <label for="bailAmount">Bail amount</label>
          <input
            id="bailAmount"
            v-model="formData.bailAmount"
            type="text"
          />
        </div>
        
        <div class="form-group">
          <label for="whereJailed">Facility</label>
          <input
            id="whereJailed"
            v-model="formData.whereJailed"
            type="text"
          />
        </div>
        
        <div class="button-group">
          <button class="save-button" @click="handleSave">Save</button>
          <button class="cancel-button" @click="handleClose">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</Teleport>
</template>

<script>
import axios from 'axios';

export default {
  name: 'EditRecordDialog',
  
  props: {
    record: {
      type: Object,
      required: true
    }
  },
  
  data() {
    return {
      formData: {
        bookingNumber: '',
        detainee: '',
        bailAmount: '',
        whereJailed: ''
      }
    };
  },
  
  created() {
    // Initialize form with current record data
    this.formData = {
      bookingNumber: this.record.bookingNumber,
      detainee: this.record.detainee,
      bailAmount: this.record.bailAmount,
      whereJailed: this.record.whereJailed
    };
    
    // Add ESC key listener
    document.addEventListener('keydown', this.handleEscKey);
  },
  
  beforeUnmount() {
    document.removeEventListener('keydown', this.handleEscKey);
  },
  
  methods: {
    handleEscKey(event) {
      if (event.key === 'Escape') {
        this.handleClose();
      }
    },
    
    async handleSave() {
      try {
        await axios.put(`/portaldb/db/updateCallProperties/${this.record.callSid}`, this.formData);
        this.$emit('close');
      } catch (error) {
        console.error('Error updating record:', error);
      }
    },
    
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>

.edit-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
  animation: fadeIn 0.2s ease-out;
  background-color: rgba(0, 0, 0, 0.5);
}

.edit-dialog {
  position: relative;
  background-color: #f5f5dc;
  border: 2px solid #d2b48c;
  border-radius: 8px;
  padding: 20px;
  width: 90%;
  max-width: 500px;
  animation: fadeIn 0.2s ease-out;
  z-index: 9999;
}

.form-group {
  margin-bottom: 16px;
}

.form-group label {
  display: block;
  margin-bottom: 8px;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 8px;
  border: 1px solid #d2b48c;
  border-radius: 4px;
  font-size: 16px;
}

.form-group input:focus {
  outline: none;
  border-color: #8b4513;
  box-shadow: 0 0 0 2px rgba(139, 69, 19, 0.1);
}

.button-group {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
}

.save-button, .cancel-button {
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid transparent;
}

.save-button {
  background-color: #8b4513;
  color: white;
}

.save-button:hover {
  background-color: #734009;
}

.cancel-button {
  background-color: #f5f5f5;
  border-color: #d2b48c;
  color: #666;
}

.cancel-button:hover {
  background-color: #e8e8e8;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .edit-dialog {
    width: 95%;
    padding: 16px;
  }
  
  .form-group input {
    font-size: 16px; /* Prevents iOS zoom */
    padding: 12px 8px; /* Larger touch target */
  }
  
  .button-group button {
    padding: 12px 16px; /* Larger touch target */
  }
}
</style>
